import React, { useEffect, useState } from "react";
import Datatable from "../../../components/shared/datatable/Datatable";
import { useGetEmployeeAttendanceReportListQuery } from "../employeeAttendanceApi";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone } from "../../../helpers/Utils";

const EmployeeDetailTab = ({ tab }) => {
  const { _t } = useTranslator();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [filter, setFilter] = useState({});

  const {
    data: employeeAttendanceReportList,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetEmployeeAttendanceReportListQuery({
    working_area_id: tab,
    page,
    pageSize,
    ...filter,
  });

  useEffect(() => {
    refetch();
  }, [tab]);

  const columns = [
    { label: _t("name", "Name"), accessor: "name" },
    { label: _t("email", "Email"), accessor: "email" },
    { label: _t("date_of_join", "Date of Join"), accessor: "date_of_joining", cell: ({ value }) => value ? convertToUserTimezone(value) : "" },
    { label: _t("phone_number", "Phone Number"), accessor: "phone_number" },
    {
      label: _t("status", "Status"),
      accessor: "status",
      cell: ({ value }) => (
        <span className={value === 1 ? "cmn_badge" : "cmn_badge inactive"}>
          {value === 1 ? _t("active", "Active") : _t("inactive", "Inactive")}
        </span>
      ),
    },
    { label: _t("role", "Role"), accessor: "role.name", captialize: true },
    { label: _t("address", "Address"), accessor: "address" },
  ];

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div>      
        <Datatable
          title={_t("employee_details", "Employee Details")}
          columns={columns}
          tableData={employeeAttendanceReportList?.data}
          pagination
          page={page}
          onPageChange={handlePageChange}
          showFilter={setFilter}
          showFilterButton={true}
          filterModule="staffAttendanceReport"
          isLoading={isLoading}
        />      
    </div>
  );
};

export default EmployeeDetailTab;
